import { Navigate, useLocation } from 'react-router-dom';

/**
 * 设备感知重定向组件
 * 重定向时保留 search 参数和 hash
 */
export default function DeviceRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
